<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyConfiguration"
  >
    <form
      autocomplete="off"
      class="margin-top-large"
      name="update-academia-form"
      @submit.prevent="submitForm"
    >
      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-academy">
          <span class="legend-icon">
            <i class="fas fa-link"></i>
          </span>
          {{ $t('mEditionAcademyConfiguration.fieldsets.steps.first') }}
        </legend>
        <div class="m-container-primary">
          <div class="row">
            <div class="column column-6">
              <AtomInputPrimary
                v-model="academia.nombre"
                :input-error="$v.academia.nombre.$error"
                :label="$t('mEditionAcademyConfiguration.inputs.nombre.label')"
                :message="$t('mEditionAcademyConfiguration.inputs.nombre.message')"
                :message-error="messageErrorNombre"
                name="nombre"
                reference="nombre"
                :placeholder="$t('mEditionAcademyConfiguration.inputs.nombre.placeholder')"
                type="text"
                @blur="$v.academia.nombre.$touch()"
              />
            </div>
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="academia.categoria"
                :elements="academiaCategorias"
                :input-error="$v.academia.categoria.$error"
                key-field="id"
                :label="$t('mEditionAcademyConfiguration.inputs.categoria.label')"
                :message-error="messageErrorCategoria"
                name="categoria"
                reference="categoria"
                text-field="nombre"
                @blur="$v.academia.categoria.$touch()"
              />
            </div>
          </div>
          <div class="row">
            <div class="column column-10">
              <AtomInputGroupPrimary
                v-model.trim="academia.url"
                :input-error="$v.academia.url.$error || urlInUse"
                :label="$t('mEditionAcademyConfiguration.inputs.url.label')"
                :message="$t('mEditionAcademyConfiguration.inputs.url.message')"
                :message-warning="$t('mEditionAcademyConfiguration.inputs.url.messageWarning')"
                :message-error="messageErrorUrl"
                name="url"
                :placeholder="$t('mEditionAcademyConfiguration.inputs.url.placeholder')"
                reference="url"
                :span-input="academiaDomain"
                type="text"
                @blur="$v.academia.url.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-academy">
          <span class="legend-icon">
            <i class="fas fa-palette"></i>
          </span>
          {{ $t('mEditionAcademyConfiguration.fieldsets.steps.second') }}
        </legend>
        <div class="m-container-primary">
          <div class="row">
            <div class="column column-4">
              <AtomLogoEdition
                clase="academy"
                entity="academia"
                :logo-img="academia.imagen"
                @changeLogoImage="changeLogoImage"
              />
            </div>
            <div class="column column-3">
              <AtomRadioButtonPrimary
                v-model="colorSelected"
                :radio-button-primary="radioButtonPrimary"
                :value="0"
                :text="$t('mEditionAcademyConfiguration.inputs.multicolor.label')"
              />
              <p class="m-edition-academy-configuration-multicolor">&nbsp;
              </p>
            </div>
            <div class="column column-3">
              <AtomRadioButtonPrimary
                v-model="colorSelected"
                :radio-button-primary="radioButtonPrimary"
                :value="1"
                :text="$t('mEditionAcademyConfiguration.inputs.color.label')"
              />
              <AtomColorPicker
                :color="academia.color"
                name="color"
                type="text"
                @changeColor="changeColor"
                @click="colorSelected = 1"
                @errorColor="setErrorColor"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="m-form-action">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAcademyConfiguration',

  data () {
    return {
      academia: {
        categoria: '',
        color: '',
        imagen: '',
        nombre: '',
        url: ''
      },

      academiaCategorias: [],
      academiaDomain: '',
      academiaId: '',

      buttonPrimary: {
        action: 'GUARDAR',
        class: 'a-button-academy-primary',
        sending: false
      },

      colorSelected: null,
      currentUrl: '',
      errorColor: false,
      // TODO: Fixear defaultColor, script anterior con getPropertyValue() da error
      defaultColor: '#82aadc',

      radioButtonPrimary: {
        labelClass: 'a-radiobutton-academy-primary',
        name: 'activacion'
      },

      showLoadingState: 0,
      urlInUse: false
    }
  },

  validations: {
    academia: {
      categoria: {
        required
      },

      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(5),
        required
      },

      url: {
        maxLength: maxLength(120),
        minLength: minLength(3),
        required
      }
    }
  },

  computed: {
    messageErrorCategoria () {
      return this.$validation.getValidationMessage('mEditionAcademyConfiguration', this.$v.academia.categoria, 'categoria')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionAcademyConfiguration', this.$v.academia.nombre, 'nombre')
    },

    messageErrorUrl () {
      // TODO: colocar mensaje de error de url en uso en archivo de traducción
      if (this.urlInUse) {
        return 'La Url ingresada ya está en uso, intenta con una diferente. De 3 a 120 caracteres.'
      } else {
        return this.$validation.getValidationMessage('mEditionAcademyConfiguration', this.$v.academia.url, 'url')
      }
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    'academia.url' () {
      this.academia.url = this.$utils.stringToSlug(this.academia.url)
      this.validateAcademyUrlInUse()
    },

    '$store.getters.getAcademyData' () {
      this.academia = {
        nombre: this.$store.getters.getAcademyData.nombre,
        url: this.$store.getters.getAcademyData.url,
        categoria: this.$store.getters.getAcademyData.categoria.id,
        color: this.$store.getters.getAcademyData.color ? this.$store.getters.getAcademyData.color : this.defaultColor,
        imagen: this.$store.getters.getAcademyData.ruta_logo
      }

      this.academiaId = this.$store.getters.getAcademyData.id
      this.currentUrl = this.$store.getters.getAcademyData.url
      this.colorSelected = this.$store.getters.getAcademyData.color !== '' ? 1 : 0
    },

    updatedData () {
      if (this.$modal.methodToRun === 'updateAcademia') {
        this.updateAcademia()
      }
    }
  },

  created () {
    this.academiaDomain = `${this.$utils.getMarketPlaceDomain()}/`
    this.readAcademiaCategorias()
    this.getStoredAcademyData()
  },

  methods: {
    changeColor (color) {
      this.academia.color = color
      // this.colorSelected = 1
      this.errorColor = false
    },

    changeLogoImage (logoImg) {
      this.academia.imagen = logoImg
    },

    getStoredAcademyData () {
      this.academia = {
        nombre: this.$store.getters.getAcademyData.nombre,
        url: this.$store.getters.getAcademyData.url,
        categoria: this.$store.getters.getAcademyData.categoria.id,
        color: this.$store.getters.getAcademyData.color ? this.$store.getters.getAcademyData.color : this.defaultColor,
        imagen: this.$store.getters.getAcademyData.ruta_logo
      }

      this.academiaId = this.$store.getters.getAcademyData.id
      this.currentUrl = this.$store.getters.getAcademyData.url
      this.colorSelected = this.$store.getters.getAcademyData.color !== '' ? 1 : 0
      this.showLoadingState++
    },

    readAcademiaCategorias () {
      this.$services.read('academia', 'readAcademiaCategorias')
        .then(response => {
          this.academiaCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setErrorColor (error) {
      this.errorColor = error
    },

    submitForm () {
      if (this.currentUrl !== this.academia.url) {
        this.$modal.showModal('MoleculeEditionAcademyConfigurationModalEdit')
      } else {
        this.updateAcademia()
      }
    },

    updateAcademia () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.$v.$invalid && !this.urlInUse && !this.buttonPrimary.sending && !this.errorColor) {
        this.buttonPrimary.sending = true
        if (this.colorSelected === 0) {
          this.academia.color = ''
        }
        this.$services.update('academia', 'updateAcademia', this.academia, [this.academiaId])
          .then(response => {
            let currentAcademy = Object.assign({}, this.$store.getters.getAcademyData)
            currentAcademy.categoria.id = response.data.categoria.id
            currentAcademy.color = response.data.color
            currentAcademy.nombre = response.data.nombre
            currentAcademy.ruta_logo = response.data.ruta_logo
            currentAcademy.url = response.data.url
            localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
            this.$store.commit('setAcademyData', currentAcademy)
            this.$license.readAcademiaConfiguracionGlobal()
            this.$alerts.pushAlert('mEditionAcademyConfiguration', 'updateAcademia', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyConfiguration', 'updateAcademia', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    validateAcademyUrlInUse () {
      if (this.academia.url !== '') {
        this.$services.read('academia', 'readAcademiaValidUrl', this.academia.url, [this.academiaId, this.academia.url])
          .then(response => {
            this.urlInUse = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>
